import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const adminApi = axios.create({ baseURL: API });
export const viewerApi = axios.create({ baseURL: API });

// Backwards-compatible alias for the content-admin screens.
export const api = adminApi;

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("ysvlive_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

viewerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("ysvlive_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

viewerApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.dispatchEvent(new Event("ysvlive:session-invalid"));
    } else if (error.response?.status === 403) {
      window.dispatchEvent(new Event("ysvlive:access-changed"));
    }
    return Promise.reject(error);
  },
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
